import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/PicIndex.vue')
  },
  {
    path: '/pic',
    name: 'pic_index',
    component: () => import('../views/PicIndex.vue')
  },
  {
    path: '/pic_home',
    name: 'pic_home',
    component: () => import('../views/PicHome.vue')
  },
  {
    path: '/video',
    name: 'video_index',
    component: () => import('../views/VideoIndex.vue')
  },
  {
    path: '/video_home',
    name: 'video_home',
    component: () => import('../views/VideoHome.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/Admin.vue')
  },
  {
    path: '/download/:mid',
    name: 'download',
    component: () => import('../views/Download.vue')
  },
  {
    path: '/pic_download',
    name: 'pic_download',
    component: () => import('../views/PicDownload.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  if (to.path === '/pic_home' || to.path === '/video_home') {
    if (!token) {
      // 无 token，跳转到登录页
      next({
        path: '/pic'
      })
    } else {
      next()
    }
  }
  next()
})

export default router
